import axios from 'axios';
import { isValidEmail } from '../common.js';

export default () => {
  return {
    isProcessing: false,
    firstName: '',
    lastName: '',
    email: '',
    feedback: null,
    options: [],
    extraOptions: false,

    async init(extraOptions) {
      this.extraOptions = extraOptions;
      if (!this.extraOptions) {
        this.options = ['Impact Direct'];
      }
      if (this.extraOptions) {
        this.options = [];
      }

      this.$watch('firstName, lastName, email, options', () => {
        this.feedback = null;
      });
    },

    async submit(event) {
      event.preventDefault();
      this.isProcessing = true;

      if (!this.firstName) {
        this.isProcessing = false;

        this.feedback = 'Please enter your first name.';
        this.$refs.firstName.focus();
        return;
      }

      if (!this.lastName) {
        this.isProcessing = false;

        this.feedback = 'Please enter your last name.';
        this.$refs.lastName.focus();
        return;
      }

      if (this.extraOptions) {
        if (this.options.length === 0) {
          this.isProcessing = false;

          this.feedback = 'Please select at least one mailing list.';
          return;
        }
      }
      if (!this.email || !isValidEmail(this.email)) {
        this.isProcessing = false;

        this.feedback = 'Please enter a valid email address.';
        this.$refs.email.focus();
        return;
      }

      const form = document.forms.namedItem('newsletter');
      const postUrl = form.action;
      const payload = new FormData(form);
      payload.set('FirstName', this.firstName);
      payload.set('LastName', this.lastName);
      payload.set('EmailAddress', this.email);
      payload.set('Mailings[]', this.options);
      payload.append('is-js', true);

    // This has to be generated programmitically to work with our set-up
      grecaptcha.ready(() => {
        grecaptcha
          .execute('6Lc1yyUqAAAAAJqcL7M9uU7d2R5I8otXkkwrdBjw', { action: 'submit' })
          .then(async (token) => {
            payload.set('g-recaptcha-response', token);
            try {
              const response = await axios.post(postUrl, payload);

              if (response.data.status === 'error') {
                this.feedback = `Something went wrong... ${response.data.message}`;
                this.isProcessing = false;
                return;
              }

              this.feedback = `Thank you. ${response.data.message}`;
            } catch (error) {
              this.feedback = `Something went wrong... ${error.response.data.message}`;
            } finally {
              this.isProcessing = false;
            }
          });
      });
    },
  };
};
